module.exports = __webpack_public_path__ + "images/application/templates/reset-password-alt-8428f04e.png";